import type { ErrorComponentProps } from '@tanstack/react-router'

import { E500 } from '@/components/exceptions/E500.tsx'

export function Ex({ error }: { error: ErrorComponentProps }) {
  console.error(error)
  return (
    <div>
      <E500 />
    </div>
  )
}
